var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardsPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.4588 9.125L76.8755 6.79167V44.4167L87.0005 20C88.7088 15.75 86.7505 10.875 82.4588 9.125ZM1.20882 24.5417L21.8755 74.3333C23.1672 77.5417 26.2088 79.5 29.4172 79.5833C30.5005 79.5833 31.6255 79.375 32.7088 78.9167L63.4171 66.2083C66.5421 64.9167 68.4588 61.8333 68.5421 58.75C68.5838 57.6667 68.3755 56.4583 68.0005 55.375L47.1671 5.58333C45.9588 2.375 42.8755 0.416667 39.6255 0.375C38.5421 0.375 37.4588 0.625 36.4171 1L5.75048 13.7083C1.50048 15.4583 -0.541182 20.3333 1.20882 24.5417ZM68.5005 8.70833C68.5005 6.4982 67.6225 4.37858 66.0597 2.81578C64.4969 1.25297 62.3773 0.375 60.1672 0.375H54.1255L68.5005 35.125",
    fill: "#88B1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsPay);
export default __webpack_public_path__ + "static/media/CardsPay.9b961dd09f9ac4893fe2fb42bf0f5854.svg";
export { ForwardRef as ReactComponent };